/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconArrowLeft({ className }){
  return (
    <svg
      className={className}
      fill="none"
      height="17"
      viewBox="0 0 18 17"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29541 16.2159C7.68882 16.6036 8.32196 16.5989 8.70959 16.2055C9.09721 15.8121 9.09252 15.1789 8.69911 14.7913L3.32876 9.4999H16.9999C17.5522 9.4999 17.9999 9.05218 17.9999 8.4999C17.9999 7.94761 17.5522 7.4999 16.9999 7.4999H3.33536L8.69911 2.21501C9.09252 1.82739 9.09721 1.19424 8.70959 0.800835C8.32196 0.407429 7.68882 0.402741 7.29541 0.790362L0.371221 7.61275C-0.125693 8.10236 -0.125694 8.90395 0.371221 9.39356L7.29541 16.2159Z"
        fill="#5E811E"
      />
    </svg>
  );
}
IconArrowLeft.propTypes = {
  className: PropTypes.string
};
